export default {
  methods: {
    timeTampToTime (timestamp, is13Place = true) {
      const date = new Date(timestamp * (is13Place ? 1 : 1000)) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      const Y = date.getFullYear() + '-'
      const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
      const D = this.zeroize(date.getDate()) + ' '
      // const h = this.zeroize(date.getHours()) + ':'
      // const m = this.zeroize(date.getMinutes()) + ':'
      // const s = this.zeroize(date.getSeconds())
      // return Y + M + D + h + m + s
      return Y + M + D
    },
    zeroize (num) {
      return num < 10 ? '0' + num : num
    },
    timeDiff (published) {
      var now = new Date()
      var date3 = now.getTime() - published

      // 计算相差年数
      var years = Math.floor(date3 / (356 * 24 * 3600 * 1000))
      var mouths = Math.floor(date3 / (30 * 24 * 3600 * 1000))
      // 计算出相差天数
      var days = Math.floor(date3 / (24 * 3600 * 1000))
      // 计算出小时数
      var hours = Math.floor(date3 / (3600 * 1000))
      // 计算相差分钟数
      var minutes = Math.floor(date3 / (60 * 1000))
      // 计算相差秒数
      var seconds = Math.floor(date3 / 1000)

      if (years > 0) {
        return years + '年前'
      }

      if (mouths > 0) {
        return mouths + '月前'
      }

      if (days > 0) {
        return days + '天前'
      }

      if (hours > 0) {
        return hours + '小时前'
      }

      if (minutes > 0) {
        return minutes + '分钟前'
      }
      if (seconds > 0) {
        return seconds + '秒前'
      }
    }
  }
}
